import type { PlayersApi } from "@/v2/api/metadata/players";
import type { DialogConfig } from "@/v2/framework/dialog/types";
import { notify, notifyApiError } from "@/v2/notifications/notify";
import { NXGDSStatusVariant } from "@nsftx/seven-nxg-design-system-backoffice";

export function createDeleteDialog(options: { playersApi: PlayersApi }): DialogConfig {
  const { playersApi } = options;

  return {
    id: "delete-player",
    title: "Delete player",
    description: `Are you sure you want to delete this player?`,
    layout: {
      type: "nxgds-dialog",
      actions: [
        { intent: "dismiss", label: "Cancel", variant: "secondary" },
        { intent: "submit", label: "Delete", variant: "danger" },
      ],
    },
    structure: {
      type: "flat",
      children: [],
    },
    api: {
      submit: async (_data, dialogCtx) => {
        try {
          await playersApi.delete(dialogCtx.row?.id);
          notify({
            variant: NXGDSStatusVariant.Positive,
            text: `You have successfully deleted "${dialogCtx.row?.name}" player.`,
          });
        } catch (error) {
          notifyApiError(error, `Unable to delete "${dialogCtx.row?.name}" player.`);
        }
      },
    },
  };
}
